

















































import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import AppDialog from '@/components/AppDialog.vue'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppTableDate from '@/components/AppTableDate.vue'
import AppSearch from '@/components/AppSearch.vue'
import FilterTextSearch from '@/components/FilterTextSearch.vue'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import SearchAccount from '@/mixins/search-queries/search-account'
import SearchCarrier from '@/mixins/search-queries/search-carrier'
import SearchCarrierProduct from '@/mixins/search-queries/search-carrier-product'
import { Task } from '@/modules/Task/interfaces/task'
import { taskPriorityColor, taskStatusColor, taskStatus, taskPriority, taskStatusColorKeys, taskPriorityKeys, taskStatusKeys, taskPriorityValues, taskStatusValues } from '@/modules/Task/helpers/task'

@Component({
  components: {
    AppDialog,
    AppBreadcrumbs,
    AppTableDate,
    AppSearch,
    FilterTextSearch
  }
})
export default class TasksDialog extends mixins(SearchAccount, SearchCarrier, SearchCarrierProduct) {
  @Prop({ type: Boolean }) readonly show!: boolean
  @Prop({ type: String }) readonly title!: string
  @Prop({ type: Array }) readonly tasks!: Task[]

  taskPriorityColor = taskPriorityColor
  taskStatusColor = taskStatusColor
  taskStatus = taskStatus
  taskPriority = taskPriority
  taskPriorityValues = taskPriorityValues
  taskStatusValues = taskStatusValues
  showDialog = false

  taskTableColumn = [
    { field: 'status',
      title: 'Status',
      slots: { default: 'status_default' },
      resizable: true
    },
    { field: 'priority',
      title: 'Priority',
      slots: { default: 'priority_default' },
      resizable: true,
      width: 150
    },
    { field: 'title',
      title: 'Title',
      slots: { default: 'title_default' },
      resizable: true
    },
    { field: 'creator',
      title: 'Creator',
      slots: { default: 'creator_default' },
      resizable: true
    },
    { field: 'duedate',
      title: 'Due Date',
      slots: { default: 'duedate_default' },
      resizable: true,
      width: 120
    },
    { field: 'assign',
      title: 'Assign To',
      slots: { default: 'assignees_default' },
      resizable: true
    },
    { field: 'notes',
      title: 'Notes',
      slots: { default: 'notes_default' },
      resizable: true
    },
    { field: 'createdAt',
      title: 'Creation Date',
      slots: { default: 'created_at' },
      resizable: true,
      width: 120
    }
  ]

  tableOptions = {
    loading: false,
    tablePage: tablePerPageOptions(),
    sortBy: 'id',
    sortDesc: true
  }

  candidatesPolicyNumber: string[] = []

  filteredTasks: Task[] = []

  get tasksPerPage () {
    const { tablePage } = this.tableOptions
    const { currentPage, pageSize } = tablePage
    const offset = (currentPage - 1) * pageSize
    return this.$R.slice(offset, pageSize + offset, this.filteredTasks)
  }

  @Watch('show')
  async onShowChanged (val: boolean) {
    this.showDialog = val
  }

  @Watch('tasks')
  onTasksChanged (val: Task[]) {
    this.tableOptions.loading = false
    this.tableOptions.tablePage.total = val.length
    this.tableOptions.tablePage.currentPage = 1
    this.filteredTasks = val
  }

  sortTable (column: any) {
    this.tableOptions.sortBy = column.property
    this.tableOptions.sortDesc = column.order === 'desc'
    this.filterTasks()
  }

  handlePageChange (pageData: any) {
    this.tableOptions.tablePage.currentPage = pageData.currentPage
    this.tableOptions.tablePage.pageSize = pageData.pageSize
  }

  filterTasks () {
    const { tasks } = this
    const { sortBy, sortDesc } = this.tableOptions

    let filteredTasks = [...tasks]

    this.filteredTasks = sortDesc
      ? this.$R.sortWith([this.$R.descend(this.$R.prop(sortBy))])(filteredTasks)
      : this.$R.sortWith([this.$R.ascend(this.$R.prop(sortBy))])(filteredTasks)

    this.tableOptions.tablePage.total = filteredTasks.length
  }

  @Emit('cancel')
  handleCancel () {
    // do nothing
  }

  routeTo (name: string, params: any) {
    this.$router.push({
      name,
      params
    })
  }

  routeToDetail (item: any) {
    this.routeTo('TaskDetail', {
      id: item.id
    })
  }
}
